"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const react_query_1 = require("@tanstack/react-query");
const antd_1 = require("antd");
const NewApplication_1 = __importDefault(require("./NewApplication"));
const ManageApplication_1 = __importDefault(require("./ManageApplication"));
const DomainController_1 = __importDefault(require("../DomainController"));
const applications_1 = require("../../services/applications");
const queryKeys_1 = __importDefault(require("../../constants/queryKeys"));
const handleRecordAction = (text, { appId }) => ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, Object.assign({ to: `/applications/manage/${appId}`, state: appId }, { children: text }), appId));
const columns = [
    { title: 'Name', dataIndex: 'appName', key: 'appName', render: handleRecordAction },
    { title: 'Application ID', dataIndex: 'appId', key: 'appId' },
    { title: 'URL Path', dataIndex: 'contextRoot', key: 'contextRoot' },
    { title: 'Provisioned Access', dataIndex: 'isProvisionedAccess', key: 'isProvisionedAccess',
        render: (flag) => (flag ? 'Yes' : 'No'),
    },
];
const Applications = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { isLoading, data } = (0, react_query_1.useQuery)([queryKeys_1.default.APPLICATIONS.ALL], (0, applications_1.getApplications)(), {
        onError: (err) => {
            const { status, data: { msg } } = err.response;
            switch (status) {
                case 404: return navigate('/applications/404', { state: { comingFrom: '' } });
                case 500: return navigate('/applications/500');
                default: antd_1.message.error(msg);
            }
        },
    });
    const newData = data === null || data === void 0 ? void 0 : data.filter(({ isActive }) => isActive);
    return ((0, jsx_runtime_1.jsx)(DomainController_1.default, { apiContext: '/applications', urlPath: '/applications', loading: isLoading, columns: columns, data: newData, title: 'Applications', componentForNew: (0, jsx_runtime_1.jsx)(NewApplication_1.default, {}), componentForManage: (0, jsx_runtime_1.jsx)(ManageApplication_1.default, {}), primaryKey: 'appId' }));
};
exports.default = Applications;
